'use client';

import { useSyncExternalStore as useSyncExternalStore$1 } from 'use-sync-external-store/shim/index.js';
const useSyncExternalStore = useSyncExternalStore$1;
export { useSyncExternalStore };